/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rowSpecifications[_ngcontent-%COMP%]{margin-left:0!important;margin-right:0!important}.rowTitleSpecifications[_ngcontent-%COMP%]{margin-left:0!important;margin-right:0!important;height:40px!important;line-height:40px!important;padding:0 10px!important}.rowSpecEven[_ngcontent-%COMP%]{background-color:var(--background-tableroweven)!important;color:var(--foreground-tableroweven)!important}.rowSpecOdd[_ngcontent-%COMP%]{background-color:var(--background-tablerowodd)!important;color:var(--foreground-tablerowodd)!important}"];
export { styles as styles };
